module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_11.d2bcfa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_11.png
// module id = wmrZ
// module chunks = 10